export interface NotificationContact {
  id?: number;
  email: string | null;
  phone: string | null;
  locale_id?: string;
  send_by_phone?: boolean;
  send_by_email?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export interface NotificationContactPayload {
  email: string | null;
  phone: string | null;
}

export interface NotificationModel {
  id?: number;
  type: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  contacts: NotificationContact[];
}

export interface NotificationPayload {
  id?: number;
  type: string;
  contacts: NotificationContactPayload[];
}

export type NotificationList = Array<NotificationModel>;

export const NOTIFICATION_TYPES = {
  failedPaymentsReport: 'FAILED_PAYMENTS_REPORT',
  paidPaymentsReport: 'PAID_PAYMENTS_REPORT',
  failedRecurringsReport: 'FAILED_RECURRINGS_REPORT',
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];

export default NotificationModel;
